"use client";

import dynamic from "next/dynamic";

const LandingPageViewTracker = dynamic(
  () => import("@/components/analytics/LandingPageViewTracker"),
  { ssr: false },
);

export default function LandingPageViewTrackerLazy() {
  return <LandingPageViewTracker />;
}
